var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"progress",staticStyle:{"height":"4px"}},[_c('div',{staticClass:"progress-bar bg-blue",style:(_vm.progressStyle(_vm.session.progress_percent)),attrs:{"role":"progressbar","aria-valuenow":_vm.session.progress_percent,"aria-valuemin":"0","aria-valuemax":"100","aria-label":"Scenario progress"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }